import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CopilotApiService } from './copilot-api-service';
import { Carrier } from '../model/carrier';

@Injectable({
  providedIn: 'root'
})
export class HosCopilotService {
  // Emits the latest list of carriers; starts as empty list
  public readonly carriers$ = new BehaviorSubject<Carrier[]>([]);

  constructor(private api: CopilotApiService) {
    this.loadCarriers();
  }

  public loadCarriers(businessPartner: string = 'FleetBooster', businessPartnerId?: number | null): void {
    this.api.getCarriers(businessPartner, businessPartnerId).subscribe({
      next: (list) => {
        this.carriers$.next((list || []).slice());
      },
      error: () => {
        this.carriers$.next([]);
      }
    });
  }
}


